import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import moment from 'moment-timezone'
import { List, Loader } from 'semantic-ui-react'
import DataContext from '../../../../contexts/DataContext'
import { LOAD_USER_EXTERNAL_ACCOUNT_STATUSES } from '../../../../graphql/user'

const ProjectOwnerExternalAccountStatuses = ({ owner }) => {
    const { user } = useContext(DataContext)

    const { data, loading, error } = useQuery(LOAD_USER_EXTERNAL_ACCOUNT_STATUSES, {
        variables: { id: owner.id },
    })
    
    if (loading) return <Loader active inline="centered" />
    if (error) return <p>Error loading external account statuses.</p>

    const { externalAccountStatuses = [] } = data.user

    const displayAccountStatus = (account) => {
        switch (account.status) {
            case 'connected':
                return (
                    <div>
                        <span style={{ color: 'green' }}>Connected</span>
                        {account.tokenExpiresAt && (
                            <span>{` (Expires ${moment.tz(account.tokenExpiresAt, user.timeZone).fromNow()})`}</span>
                        )}
                    </div>
                )
            case 'error':
                return <span style={{ color: 'red' }}>Error</span>
            default:
                return <span>{account.status}</span>
        }
    }
    if (externalAccountStatuses.length === 0) {
        return (<List.Description>(No external calendars linked.)</List.Description>)
    }
    return (
        <List.List>
            {externalAccountStatuses.map((account) => (
                <List.Item key={account.id}>
                    <List.Content>
                        <List.Header>{`${account.provider} calendar`}</List.Header>
                        <List.Description>
                        {displayAccountStatus(account)}
                        </List.Description>
                    </List.Content>
                </List.Item>
            ))}
        </List.List>
    )
}

export default ProjectOwnerExternalAccountStatuses
